import TablistContainer from './tablistContainer.factory.js';
var _tablistContainerPropsManager = function tablistContainerPropsManager(ins) {
  var className = ins.getSetting('tablistContainerClass');
  return {
    className: className
  };
};
export { _tablistContainerPropsManager as tablistContainerPropsManager };
export default TablistContainer.bind(undefined, function (ins) {
  return {
    tablistContainerPropsManager: function tablistContainerPropsManager() {
      return _tablistContainerPropsManager(ins);
    }
  };
});